import { Input } from '@alifd/next';
import wrapper from './next-wrapper';
const FormTextArea = wrapper(Input.TextArea, 'CbayelFormTextArea');
export default FormTextArea;
